/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string')) {
      if ((/^[0-9]+$/.test(time))) {
        // support "1548221490638"
        time = parseInt(time)
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), '/')
      }
    }

    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
    return value.toString().padStart(2, '0')
  })
  return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = decodeURIComponent(url.split('?')[1]).replace(/\+/g, ' ')
  if (!search) {
    return {}
  }
  const obj = {}
  const searchArr = search.split('&')
  searchArr.forEach(v => {
    const index = v.indexOf('=')
    if (index !== -1) {
      const name = v.substring(0, index)
      const val = v.substring(index + 1, v.length)
      obj[name] = val
    }
  })
  return obj
}

//将毫秒的时间转换成美式英语的时间格式,eg:3rd May 2018
export function formatDate(millinSeconds){
	var date = new Date(millinSeconds);
	var monthArr = new Array("Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Spt","Oct","Nov","Dec");
	// var suffix = new Array("st","nd","rd","th");
	
	var year = date.getFullYear(); //年
	var month = monthArr[date.getMonth()]; //月
	var ddate = date.getDate(); //日
	
	// if(ddate % 10 < 1 || ddate % 10 > 3) {
	// 	ddate = ddate + suffix[3];
	// }else if(ddate % 10 == 1) {
	// 	ddate = ddate + suffix[0];
	// } else if(ddate % 10 == 2) {
	// 	ddate = ddate + suffix[1];
	// }else {
	// 	ddate = ddate + suffix[2];
	// }
	// return month  + " "+ ddate+ " " + year;
	// return month +" "+ ddate ;
	return {year,month,ddate} ;
}

export  function formatAMPM (date) {
  let hours = date.getHours();
  let minutes = date.getMinutes();
  let ampm = hours >= 12 ? 'Pm' : 'Am';
  hours = hours % 12;
  hours = hours ? hours : 12;
  minutes = minutes.toString().padStart(2, '0');
  let strTime = hours + ':' + minutes + ' ' + ampm;
  return strTime;
}

export function sortData(data,sortIds){
  try {
      sortIds=sortIds.map(item=>parseInt(item))
      data.sort((a, b) => {
          const aIndex = sortIds.indexOf(a.id);
          const bIndex = sortIds.indexOf(b.id);
        //   return aIndex<0? bIndex- aIndex :aIndex - bIndex;
        //   return aIndex - bIndex;
        return (aIndex<0 && bIndex<0)?  b.id-a.id: aIndex - bIndex;
      });
  } catch (error) {
      console.log(error)
  }finally{
      return data
  }
  
}
export function getThumbnail(id,type='maxresdefault'){
    //maxresdefault sddefault mqdefault hqdefault

    //img = `https://i.ytimg.com/vi/${id}/maxresdefault.jpg`
    let src;
    return new Promise((resolve)=>{
        let image =new Image();
        src=`https://i.ytimg.com/vi/${id}/${type}.jpg`;
        image.src = src
        image.onload = function(){
            if(this.naturalHeight==90){
                resolve(false)
            }else{
                resolve(src)
            }
        }
        image.onerror = function(){
            resolve(false)
        }
    })


} 

export function goMap(address){
    AMap.plugin('AMap.Geocoder', function() {
        let  geocoder = new AMap.Geocoder({ city: '全国' })
        geocoder.getLocation(address, (status, result)=>{
            if (status === 'complete' && result.info === 'OK') {
            // result中对应详细地理坐标信息
                let lat=result.geocodes[0].location.lat
                let lng=result.geocodes[0].location.lng
                window.open(`https://uri.amap.com/marker?position=${lng},${lat}&name=${address}`)
            }
        })
    })
}
function replaceImg(HTML){
    return HTML.replaceAll('<img','<img style=display:none')
}
export function vHtml2String(HTML){
    const re1 = new RegExp("<.+?>", "g"); // 匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
    const arrEntities = { 'lt': '<', 'gt': '>', 'nbsp': ' ', 'amp': '&', 'quot': '"', 'ldquo': '“', 'mdash': '—', "rdquo": '”' };
    return HTML.replace(re1, '').replace(/&(lt|gt|nbsp|amp|quot|ldquo|mdash|rdquo);/ig, function (all, t) {
        return arrEntities[t];
    });
}